import { render } from "./Anomaly.vue?vue&type=template&id=1381028c"
import script from "./Anomaly.vue?vue&type=script&lang=js"
export * from "./Anomaly.vue?vue&type=script&lang=js"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__